exports.Game = require('./core/Game');
exports.Piece = require('./utils/symbols').Piece;




//////////////////
// WEBPACK FOOTER
// ./~/draughts-reader-core/src/main.js
// module id = WkCC
// module chunks = 4